const applyRoute = "/sub-vue2";

export { applyRoute };
